import { createAsyncThunk } from "@reduxjs/toolkit";
import apiBackend from "@src/apiBackend.js";


export const updateChatsAgents = createAsyncThunk(
  "/chat/updateChatsAgents",
  async ({ automationId, userId, agents }, { rejectWithValue }) => {
    try {

      const user = localStorage.getItem("user");
      const userJson = JSON.parse(user);
      const token = userJson.accessToken;

      const res = await apiBackend.post(`/chat/update-chats-agents`,
        { automationId, userId, agents },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });


      return res.data;
    } catch (error) {
      console.error("Error fetching agents:", error);

    }
  }
)



export const getAgentsByIds = createAsyncThunk(
  "/chat/getAgentsByIds",
  async (ids, { rejectWithValue }) => {
    try {

      const user = localStorage.getItem("user");
      const userJson = JSON.parse(user);
      const token = userJson.accessToken;

      const res = await apiBackend.post(`/chat/get-agents-by-ids`,
        { ids },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });


      return res.data;
    } catch (error) {
      console.error("Error fetching agents:", error);

    }
  }
)
export const getAgents = createAsyncThunk(
  "/chat/getAgents",
  async ({ search },{ rejectWithValue }) => {
    const user = localStorage.getItem("user");
    const userJson = JSON.parse(user);
    const token = userJson.accessToken;
//  console.log('esto es search', search)
    try {

      const res = await apiBackend.get(`/chat/get-agents?search=${search}`, {
        // params: {
        //   search
        // },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data; 
    } catch (error) {
      console.error("Error fetching agents:", error);

    }
  }
);

export const duplicateAgent = createAsyncThunk(
  "/chat/duplicate-agent",
  async ({agent},{ rejectWithValue }) => {
    const user = localStorage.getItem("user");
    const userJson = JSON.parse(user);
    const token = userJson.accessToken;

    try {
      const res = await apiBackend.post(`/chat/duplicate-agent`,
        { agent }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data; 
    } catch (error) {
      console.error("Error fetching agents:", error);

    }
  }
);

